import { createSelector } from 'reselect';
import { SECTION_ACCESS_TYPES } from '../utils/consts';
import { getElementAccessType } from './navigation';
import getCurrentPath from './routing';
import { getUserData, isUserAdNetwork, normalizeAccountTypeName } from './user';

const READ = 1;
const WRITE = 2;
const READ_WRITE = 3;
const FEATURE_GOALS = 'goals';

const typesMap = {
    read: READ,
    write: WRITE,
    readWrite: READ_WRITE,
};

const GET_ADNETWORK_MAP = () => ({
    '/react/link-management': READ,
});

const GET_AGENCY_MAP = manageLinksAccessType => ({
    '/react/link-management': manageLinksAccessType === SECTION_ACCESS_TYPES.VIEW ? READ : READ_WRITE,
    '/react/singular-events': READ,
});

const ACCOUNT_TYPES_MAP = {
    ad_network: manageLinksAccessType => GET_ADNETWORK_MAP(manageLinksAccessType),
    agency_account: manageLinksAccessType => GET_AGENCY_MAP(manageLinksAccessType),
};

const getUserMap = createSelector(
    [getUserData, getElementAccessType('manage_links')],
    (userData, manageLinksAccessType) => {
        const accountType = normalizeAccountTypeName(userData.account_type_name);
        return ACCOUNT_TYPES_MAP[accountType]?.(manageLinksAccessType) || {};
    }
);

export const getFeaturePermissions = createSelector([getUserMap, getCurrentPath], (userMap, currentPath) => {
    return {
        typesMap,
        permission: userMap[currentPath.pathname] || READ_WRITE,
    };
});

export const isGoalsReportPermitted = createSelector([isUserAdNetwork, getUserData], (isAdNetwork, userData) => {
    return !isAdNetwork && userData.feature_flags?.includes(FEATURE_GOALS);
});
